import { render, staticRenderFns } from "./ProjectOrderingDialog.vue?vue&type=template&id=cde5c6a4&scoped=true"
import script from "./ProjectOrderingDialog.vue?vue&type=script&lang=js"
export * from "./ProjectOrderingDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectOrderingDialog.vue?vue&type=style&index=0&id=cde5c6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde5c6a4",
  null
  
)

export default component.exports